export default __webpack_public_path__ + "static/media/arrow.19f6cfe1.svg";